"use client";

import { ThemeProvider } from "next-themes";
import { MDXProvider } from "@mdx-js/react";

// Import your MDX components


export function Providers({ children }: { children: React.ReactNode }) {
	return (
		<ThemeProvider attribute="class" enableSystem={false} defaultTheme="light">
			{children}
		</ThemeProvider>
	);
}
